import { useUpdateTokenAirdrop } from './useUpdateTokenAirdrop';
import { useUpdateNFTAirdrop } from './useUpdateNFTAirdrop';
export const useUpdateCampaign = (
  campaignAddress: string,
  campaignType: string
) => {
  // update

  const { updateTokenAirdrop, updateTokenAirdropState } =
    useUpdateTokenAirdrop(campaignAddress);
  const { updateNFTAirdrop, updateNFTAirdropState } =
    useUpdateNFTAirdrop(campaignAddress);

  return campaignType === 'TOKEN'
    ? [updateTokenAirdrop, updateTokenAirdropState]
    : [updateNFTAirdrop, updateNFTAirdropState];
};
